import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const Header = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="py-8 md:py-12">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img
            src="MauroHead.jpg"
            alt="Mauro Alvarez"
            className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover grayscale hover:grayscale-0 transition-all duration-300"
          />
          <a
            href="/"
            className="font-serif text-xl md:text-2xl font-semibold text-foreground hover:opacity-70 transition-opacity duration-200"
          >
            Mauro Alvarez
          </a>
        </div>

        <button
          onClick={toggleTheme}
          className="p-2 rounded-full hover:bg-muted transition-colors duration-200"
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          {theme === 'light' ? (
            <Moon className="w-5 h-5 text-foreground" />
          ) : (
            <Sun className="w-5 h-5 text-foreground" />
          )}
        </button>
      </div>
    </header>
  );
};

export default Header;
